import { render, staticRenderFns } from "./DoctorDashboard.vue?vue&type=template&id=78d420d8&scoped=true&"
import script from "./DoctorDashboard.vue?vue&type=script&lang=js&"
export * from "./DoctorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DoctorDashboard.vue?vue&type=style&index=0&id=78d420d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d420d8",
  null
  
)

export default component.exports